module.exports = __webpack_public_path__ + "img/Anmeldung_tall.eed4d7df.jpg";